import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import useRead from "./useRead";

const useTdsData = () => {
  const { company_employee_id } = useParams();
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Fetch financial years list
  const { list: financialYearsList } = useRead({
    url: "tds/financial-year/list",
    initialData: {
      page_number: 0,
      limit: 100,
    },
    method: "GET",
  });

  // Fetch TDS user response data
  const { list: tdsData, setGetListParams } = useRead({
    url: "tds/get-user-response",
    initialData: {
      company_employee_id: parseInt(company_employee_id),
      screen: "MASTER",
    },
    method: "GET",
    enabled: !!company_employee_id,
    onSuccess: (data) => {
      // On initial load, set the financial year from API response
      if (isInitialLoad && data?.data?.main_submission_data?.financial_year) {
        const fyFromResponse = data.data.main_submission_data.financial_year;
        setSelectedFinancialYear({
          financial_year_id: fyFromResponse.financial_year_id,
          label: fyFromResponse.label,
        });
        setIsInitialLoad(false);
      } else if (isInitialLoad && data?.data?.financial_years) {
        // Handle the no-declaration case where financial_years is an object, not an array
        const financialYearsData = data.data.financial_years;
        if (financialYearsData.financial_year_id) {
          // It's a single object, not an array
          setSelectedFinancialYear({
            financial_year_id: financialYearsData.financial_year_id,
            label: financialYearsData.label,
          });
        }
        setIsInitialLoad(false);
      } else if (isInitialLoad && data?.data?.financial_year?.[0]) {
        // If financial_year is an array, use the first active one
        const defaultFy = data.data.financial_year.find(fy => fy.active === "1") || data.data.financial_year[0];
        setSelectedFinancialYear({
          financial_year_id: defaultFy.financial_year_id,
          label: defaultFy.label,
        });
        setIsInitialLoad(false);
      }
    },
  });

  // Transform financial years for dropdown
  const financialYearOptions = financialYearsList?.data?.data?.map(fy => ({
    financial_year_id: fy.financial_year_id,
    label: fy.label,
    value: fy.financial_year_id,
  })) || [];

  // Handle financial year change
  const handleFinancialYearChange = (newFinancialYear) => {
    setSelectedFinancialYear(newFinancialYear);
    // Refetch data with new financial year
    setGetListParams({
      company_employee_id: parseInt(company_employee_id),
      screen: "MASTER",
      financial_year_id: newFinancialYear.financial_year_id,
    });
  };

  return {
    tdsData: tdsData?.data,
    isLoading: tdsData?.isLoading,
    financialYearOptions,
    selectedFinancialYear,
    handleFinancialYearChange,
    hasDeclarations: !!(tdsData?.data?.data?.main_submission_data),
  };
};

export default useTdsData;
